import React, { useState, useEffect } from "react";
import { onboardingConfig } from "./config";
import style from "./Onboarding.module.css";
import ImageSlide from "./Slides/ImageSlide/ImageSlide";
import AnimationSlide from "./Slides/AnimationSlide/AnimationSlide";
import { updateUserOnboardingStatus } from "../../Services/Requests.ts";

function Onboarding({ onComplete }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = onboardingConfig.pages[0].slides;
  useEffect(() => {
    const tg = window.Telegram.WebApp;
    tg.MainButton.setParams({
      text_color: "#FFFFFF", // цвет текста кнопки
      color: "#1F0234", // цвет фона кнопки
    });
    tg.MainButton.setText(slides[currentSlide].button);
    tg.MainButton.show();
    tg.MainButton.onClick(handleNext);
    tg.setHeaderColor("#1F0234");
    tg.setBackgroundColor("#000");
    tg.setBottomBarColor("#0F011A");
    updateBackButton();
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      tg.MainButton.offClick(handleNext);
      tg.BackButton.offClick(handleBack);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [currentSlide]);

  const handleNext = () => {
    const tg = window.Telegram.WebApp;
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      tg.MainButton.hide();
      onComplete();
      updateUserOnboardingStatus()
        .then((response) => {
          console.log("Статус онбординга успешно обновлен:", response);
        })
        .catch((error) => {
          console.error("Ошибка при обновлении статуса онбординга:", error);
        });
    }
  };

  const handleBack = () => {
    if (currentSlide > 0) {
      setCurrentSlide(currentSlide - 1);
    }
  };

  const handleVisibilityChange = () => {
    if (!document.hidden) {
      updateBackButton();
    }
  };

  const updateBackButton = () => {
    const tg = window.Telegram.WebApp;
    tg.BackButton.offClick(handleBack);
    if (currentSlide > 0 || document.referrer) {
      tg.BackButton.show();
      tg.BackButton.onClick(handleBack);
    } else {
      tg.BackButton.hide();
    }
  };

  const renderSlide = (slide) => {
    if (slide.media.type === "image") {
      return (
        <ImageSlide
          slide={slide}
          currentSlide={currentSlide}
          totalSlides={slides.length}
        />
      );
    } else if (slide.media.type === "animation") {
      return (
        <AnimationSlide
          slide={slide}
          currentSlide={currentSlide}
          totalSlides={slides.length}
        />
      );
    }
  };

  return (
    <div className={style.onboardingContainer}>
      {renderSlide(slides[currentSlide])}
    </div>
  );
}

export default Onboarding;
